import { z } from "zod";
import { LIMITS, optional, required } from "@shared/config";

// ── канал ────────────────────────────────────────────────────────────

/*
 * Имя канала приводится к виду адреса на глазах, до отправки, — этим занят
 * `slug` в `entities/channel`. Схема смотрит на уже приведённое: приведение
 * может оставить пустую строку («---» превращается в ничто), и это тот
 * случай, когда поле набрано, а отправлять нечего.
 */
export const channelSchema = z.object({
  name: required(LIMITS.channelName.min, LIMITS.channelName.max, "Название нужно"),
  topic: optional(LIMITS.channelTopic.max),
  where: z.string(),
});

export type ChannelForm = z.infer<typeof channelSchema>;

/**
 * Настройки существующего канала — те же поля плюс два переключателя.
 *
 * «Приватный» и «только чтение» — не поля канала, а его переопределения прав
 * для @все, но в форме они живут наравне с именем: человек правит их в одном
 * окне и сохраняет одной кнопкой, и считаться правкой они должны так же.
 */
export const channelSettingsSchema = channelSchema.extend({
  closed: z.boolean(),
  readOnly: z.boolean(),
  /** Медленный режим в секундах — строкой: так его держит список выбора. */
  slowmode: z.string(),
  /** Возрастное ограничение: клиент спрашивает о возрасте перед лентой. */
  nsfw: z.boolean(),
  /** Лимит участников голосового канала — строкой, как и медленный режим. */
  userLimit: z.string(),
});

export type ChannelSettingsForm = z.infer<typeof channelSettingsSchema>;
